import React, { useState, useCallback } from 'react'
import { hooks } from '@front/volcanion'

import { Loader } from '@front/squirtle'

import { usePhoneCall } from '@abra/hooks/ivr'
import HookUtils from '@front/volcanion/utils/hooks'

const withContainer = Component => ({ vehicle_id }) => {
  const [isCurrent, setIsCurrent] = useState(true)
  const onCall = usePhoneCall()

  const [vehicle, vehicleState] = hooks.useModel('vehicle', [vehicle_id], {
    populate: [
      'type',
      'info.model.brand',
      'options',
      'driver.info',
      'driver.auth',
      'driver.options',
      'current_job.first_step.order.source',
      'current_job.first_step.order.destination',
      'current_job.first_step.order.current_target.eta',
      'current_job.first_step.order.info',
      'current_job.first_step.order.assigned_transport',
    ],
    single: true
  })

  const user_id = vehicle?.driver?.user_id
  const [next_job] = hooks.useModelSearch('job', 'get', {
    initial_filter: {},
    forced_filter: { driver: user_id },
    mode: 'next_job',
    validate_filter: useCallback(() => !!user_id, [user_id]),
    watchers: [user_id],
    single: true,
    populate: [
      'first_step.order.source',
      'first_step.order.destination',
      'first_step.order.current_target.eta',
      'first_step.order.info',
      'first_step.order.assigned_transport',
    ],
  })

  const toogleIsCurrent = useCallback(() => setIsCurrent(prev => !prev), [setIsCurrent])
  const next_order = next_job?.first_step?.order
  const order = isCurrent ? vehicle?.current_job?.first_step?.order : next_order

  const mergedProps = {
    vehicle,
    isCurrent,
    toogleIsCurrent,
    onCall,
    order,
    next_order,
  }

  return (
    <Loader isLoading={HookUtils.getLoadingState([vehicleState])}>
      <Component {...mergedProps} />
    </Loader>
  )
}

export default withContainer
